'use client';

import Link from 'next/link';

interface GlossaryTerm {
  slug: string;
  term: string;
  shortDefinition: string;
}

interface RelatedGlossaryTermsProps {
    terms?: GlossaryTerm[];
    // Back-compat: these are now ignored (data comes from terms prop)
    toolSlug?: string;
    maxTerms?: number;
    explicitSlugs?: string[];
}

export function RelatedGlossaryTerms({ terms = [] }: RelatedGlossaryTermsProps) {
    if (terms.length === 0) {
        return null;
    }
    return (<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2" id="key-security-terms">Key Security Terms</h2>
        <p className="text-gray-600">
          Understand the essential concepts behind this tool
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        {terms.map((term: GlossaryTerm) => (<Link key={term.slug} href={`/glossary/${term.slug}`} className="group bg-white rounded-lg border-2 border-gray-200 hover:border-blue-500 hover:shadow-md transition-all p-5">
            <h3 className="font-semibold text-gray-900 group-hover:text-blue-600 mb-2 text-lg">
              {term.term}
            </h3>
            <p className="text-sm text-gray-600 line-clamp-3">
              {term.shortDefinition}
            </p>
            <div className="mt-3 text-sm font-medium text-blue-600 group-hover:text-blue-700">
              Learn more →
            </div>
          </Link>))}
      </div>

      <div className="text-center">
        <Link href="/glossary" className="inline-block text-blue-600 hover:text-blue-700 font-medium text-sm">
          View all terms in our glossary →
        </Link>
      </div>
    </div>);
}
